import { DSImage } from 'shared-definitions/types'
import { nullableString } from 'shared-code/conversion'
import { ApiImageProps } from 'data-source/types.wp'
import { PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'
import { creditMapper } from 'data-source/mappers/creditMapper'

export function imageMapper(
  input: ApiImageProps | null | undefined | false,
  opts: PLinkMapperOpts
): DSImage {
  if (!input) {
    return null
  }

  return {
    src: input.src,
    srcSet: nullableString(input.srcset),
    webpSrcSet: nullableString(input.webp_srcset),
    alt: nullableString(input.alt),
    title: nullableString(input.title),
    caption: nullableString(input.caption),
    credits: input.credits !== undefined ? input.credits.map(i => creditMapper(i, opts)) : [],
    size:
      input.height && input.width
        ? {
            w: input.width,
            h: input.height,
          }
        : null,
  }
}
